//account
export const LOGIN_SUCCESS = "login-success";
export const LOGIN_FAILURE = "login-failure";
export const LOGOUT_SUCCESS = "logout_success";
export const UPDATE_USERNAME_SUCCESS = "update-username-success";
export const UPDATE_USERNAME_FAILURE = "update-username-failure";
export const TOGGLE_DEBUG_MODE = "toggle-debug-mode";
export const CHANGE_MODEL = "change-model";

//sidebar
export const TOGGLE_SIDEBAR = "toggle-sidebar";
export const OPEN_SWITCH_PLANT_MENU = "open-switch-plant-menu";
export const CLOSE_SWITCH_PLANT_MENU = "close-switch-plant-menu";
export const SWITCH_PLANT = "switch-plant";
export const CLICK_VIEW_ALL_SESSIONS = "click-view-all-sessions";
export const OPEN_SETTINGS_MENU = "open-settings-menu";
export const CLOSE_SETTINGS_MENU = "close-settings-menu";

//feedback
export const CLICK_TAB_ON_FEEDBACK_PAGE = "click-tab-on-feedback-page";
export const CLICK_FEEDBACK_TYPE_CHIP_ON_FEEDBACK_PAGE =
  "click-feedback-type-chip-on-feedback-page";
export const APPLY_SORT_ON_FEEDBACK_PAGE = "apply-sort-on-feedback-page";
export const APPLY_SEARCH_ON_FEEDBACK_PAGE = "apply-search-on-feedback-page";
export const OPEN_FEEDBACK_DIALOG_ON_FEEDBACK_PAGE =
  "open-feedback-dialog-on-feedback-page";
export const CLOSE_FEEDBACK_DIALOG_ON_FEEDBACK_PAGE =
  "close-feedback-dialog-on-feedback-page";
export const APPROVE_FEEDBACK_SUCCESS = "approve-feedback-success";
export const APPROVE_FEEDBACK_FAILURE = "approve-feedback-failure";
export const REJECT_FEEDBACK_SUCCESS = "reject-feedback-success";
export const REJECT_FEEDBACK_FAILURE = "reject-feedback-failure";
export const GO_TO_ANSWER = "go-to-answer";

//sessions
export const FOLLOWUP_BUTTON_CLICK = "followup-button-click";
export const SCROLL_TO_BOTTOM = "scroll-to-bottom";
export const OPEN_FEEDBACK_DIALOG = "open-feedback-dialog";
export const SUBMIT_FEEDBACK_SUCCESS = "submit-feedback-success";
export const SUBMIT_FEEDBACK_FAILURE = "submit-feedback-failure";
export const DELETE_FEEDBACK_SUCCESS = "delete-feedback-success";
export const DELETE_FEEDBACK_FAILURE = "delete-feedback-failure";
export const FETCH_METADATA_SUCCESS = "fetch-metadata-success";
export const FETCH_METADATA_FAILURE = "fetch-metadata-failure";
export const OPEN_SHARE_MESSAGE_MENU = "open-share-message-menu";
export const CLOSE_SHARE_MESSAGE_MENU = "close-share-message-menu";
export const COPY_MESSAGE_LINK = "copy-message-link";
export const COPY_MESSAGE_CONTENT = "copy-message-content";
export const DOWNLOAD_ENTITY = "download-entity";
export const OPEN_DEBUG_DIALOG = "open-debug-dialog";
export const CLOSE_DEBUG_DIALOG = "close-debug-dialog";
export const CLICK_MAIN_TAB_ON_DEBUG_DIALOG = "click-main-tab-on-debug-dialog";
export const CLICK_SUB_TAB_ON_DEBUG_DIALOG = "click-sub-tab-on-debug-dialog";
export const SAVE_OR_UNSAVE_MESSAGE_SUCCESS = "save-or-unsave-message-success";
export const SAVE_OR_UNSAVE_MESSAGE_FAILURE = "save-or-unsave-message-failure";
export const CLICK_TAB_ON_MESSAGE = "click-tab-on-message";
export const CLICK_NEW_SESSION_BUTTON_ON_MESSAGE_PAGE =
  "click-new-session-button-on-message-page";
export const CLICK_ON_RECORD_AUDIO_BUTTON = "click-on-record-audio-button";
export const SUBMIT_SEARCH_QUERY = "submit-search-query";
export const CLEAR_SEARCH_QUERY = "clear-search-query";
export const CLICK_BACK_BUTTON = "click-back-button";
export const CREATE_NEW_SESSION_SUCCESS = "create-new-session-success";
export const CREATE_NEW_SESSION_FAILURE = "create-new-session-failure";
export const TOGGLE_THINKING_MODE = "toggle-thinking-mode";
export const CLICK_REFINE_SEARCH_BUTTON = "click-refine-search-button";
export const CLICK_REFINE_SEARCH_WITHIN_SPECIFIC_FILES =
  "click-refine-search-within-specific-files";
export const CLICK_APPLY_SEARCH_WITHIN_FILE_CATEGORIES =
  "click-apply-search-within-file-categories";
export const CLICK_CANCEL_SEARCH_WITHIN_FILE_CATEGORIES =
  "click-cancel-search-within-file-categories";
export const SELECT_FILE_CATEGORY_REFINE_SEARCH =
  "select-file-category-refine-search";
export const SELECT_FILE_REFINE_SEARCH = "select-file-refine-search";
export const SEARCH_FILES_REFINE_SEARCH = "search-files-refine-search";
export const TOGGLE_PREVIEW_REFINE_SEARCH = "toggle-preview-refine-search";
export const PAGE_CHANGE_REFINE_SEARCH = "page-change-refine-search";
export const CLICK_CLEAR_ALL_BUTTON_REFINE_SEARCH =
  "click-clear-all-button-refine-search";
export const CLICK_APPLY_REFINE_SEARCH = "click-apply-refine-search";
export const CLICK_CANCEL_REFINE_SEARCH = "click-cancel-refine-search";
export const REMOVE_TAGGED_FILE = "remove-tagged-file";
export const REMOVE_TAGGED_CATEGORY = "remove-tagged-category";
export const SHOW_ALL_FILES_QUERY_BOX = "show-all-files-query-box";
export const GET_QUERY_INTENT_SUCCESS = "get-query-intent-success";
export const GET_QUERY_INTENT_FAILURE = "get-query-intent-failure";
export const STREAM_ANSWER_SUCCESS = "stream-answer-success";
export const STREAM_ANSWER_FAILURE = "stream-answer-failure";
export const GET_ENTITY_SUCCESS = "get-entity-success";
export const GET_ENTITY_FAILURE = "get-entity-failure";
export const CLICK_SOURCE = "click-source";
export const CLICK_ENTITY = "click-entity";
export const CLICK_TABULAR = "click-tabular";
export const CLICK_SOURCE_FULL_SCREEN = "click-source-full-screen";
export const FETCH_RELATED_DOCS_SUCCESS = "fetch-related-docs-success";
export const FETCH_RELATED_DOCS_FAILURE = "fetch-related-docs-failure";

//data-explorer
export const CLICK_TAB_ON_DATA_EXPLORER = "click-tab-on-data-explorer";
export const TOGGLE_FILTER_BUTTON_ON_FILE_EXPLORER =
  "toggle-filter-button-on-file-explorer";
export const OPEN_SORT_MENU_ON_FILE_EXPLORER =
  "open-sort-menu-on-file-explorer";
export const SELECT_SORT_OPTION_ON_FILE_EXPLORER =
  "select-sort-option-on-file-explorer";
export const SEARCH_FILES_ON_FILE_EXPLORER = "search-files-on-file-explorer";
export const SELECT_FILE_CATEGORY_ON_FILE_EXPLORER =
  "select-file-category-on-file-explorer";
export const SELECT_FILE_STATUS_ON_FILE_EXPLORER =
  "select-file-status-on-file-explorer";
export const SELECT_FILE_TYPE_ON_FILE_EXPLORER =
  "select-file-type-on-file-explorer";
export const RESET_FILTERS_ON_FILE_EXPLORER = "reset-filters-on-file-explorer";
export const SELECT_CATEGORY_ON_FILE_EXPLORER =
  "select-category-on-file-explorer";
export const PAGE_CHANGE_ON_FILE_EXPLORER = "page-change-on-file-explorer";
export const CLICK_UPLOAD_FILE_BUTTON = "click-upload-file-button";
export const UPLOAD_FILES_SUCCESS = "upload-files-success";
export const UPLOAD_FILES_FAILURE = "upload-files-failure";
export const CLICK_ACTION_MENU_ON_FILE_EXPLORER =
  "click-action-menu-on-file-explorer";
export const DELETE_FILE_SUCCESS = "delete-file-success";
export const DELETE_FILE_FAILURE = "delete-file-failure";
export const EDIT_FILE_SUCCESS = "edit-file-success";
export const EDIT_FILE_FAILURE = "edit-file-failure";
export const DOWNLOAD_FILE = "download-file";

//data-management
export const CLICK_TAB_ON_DATA_MANAGEMENT = "click-tab-on-data-management";
export const SELECT_CATEGORY_ON_DATA_MANAGEMENT =
  "select-category-on-data-management";
export const CLEAR_ALL_CATEGORIES_ON_DATA_MANAGEMENT =
  "clear-all-categories-on-data-management";
export const DELETE_CATEGORY_ON_DATA_MANAGEMENT =
  "delete-category-on-data-management";
export const SELECT_STATUS_ON_DATA_MANAGEMENT =
  "select-status-on-data-management";
export const PAGE_CHANGE_ON_DATA_MANAGEMENT = "page-change-on-data-management";
export const CLICK_ACTION_MENU_ON_DATA_MANAGEMENT =
  "click-action-menu-on-data-management";

//view-file
export const CLICK_ACTION_MENU_ON_VIEW_FILE = "click-action-menu-on-view-file";
export const GO_BACK_TO_FILES = "go-back-to-files";
export const VIEW_FILE_INFO = "view-file-info";
export const CLICK_ZOOM_IN = "click-zoom-in";
export const CLICK_ZOOM_OUT = "click-zoom-out";
export const CLICK_FIT_SCREEN = "click-fit-screen";
export const CLICK_DOWNLOAD_FILE = "click-download-file";
export const CLICK_CURRENT_PAGE = "click-current-page";
export const CLICK_NEXT_PAGE = "click-next-page";
export const CLICK_PREV_PAGE = "click-prev-page";